


import { Component, Vue } from 'vue-property-decorator';

import FloatMenu, {
  FloatMenuPosition,
} from '@/shared/components/float-menu.component.vue';
import MenuElement, {
  MenuElementBgColor,
  MenuElementBgColorHover,
} from '@/shared/components/menu-element.component.vue';

@Component({
    components: {
      FloatMenu,
      MenuElement,
    },
})
export default class PartialFloatMenu extends Vue {
  private floatMenuPosition = FloatMenuPosition;
  private menuElementBgColor = MenuElementBgColor;
  private menuElementBgColorHover = MenuElementBgColorHover;

  private option3() {
    alert('click option 3');
  }

  private option2() {
    alert('click option 2');
  }
}
